<template>
  <Dialog header="Consentement et Conditions d'Utilisation" v-model:visible="showModal" :modal="true" :closable="false" :style="{ width: '50vw' }">
    <div class="prose dark:prose-invert max-w-none">
      <h4>Bienvenue sur le portail Inaubi !</h4>
      <p>
        Avant de continuer, veuillez lire attentivement et accepter les points suivants.
      </p>
      
      <h5>1. Public Cible</h5>
      <p>
        Cet outil est exclusivement destiné aux clients, partenaires et collaborateurs d'Inaubi. 
        Il a pour but de fournir un accès centralisé à des outils et des informations techniques.
      </p>

      <h5>2. Exactitude des Données</h5>
      <p>
        Inaubi s'efforce de maintenir les informations et les données présentées sur ce portail à jour et exactes. 
        Cependant, nous ne pouvons garantir l'exhaustivité et la précision absolue des données. 
        Celles-ci sont fournies à titre indicatif et ne sauraient engager notre responsabilité.
      </p>

      <h5>3. Utilisation de l'Intelligence Artificielle</h5>
      <p>
        L'assistant Jarvin, intégré à ce portail, repose sur des technologies d'intelligence artificielle générative. 
        Bien que puissant, cet outil est susceptible de commettre des erreurs, de générer des informations incorrectes ou de produire des réponses imprécises. 
        Il est de votre responsabilité de vérifier les informations critiques avant de les utiliser.
      </p>

      <h5>4. Communications</h5>
      <p>
        En accédant à ce portail, vous acceptez que votre adresse e-mail soit ajoutée à notre liste de diffusion. 
        Vous recevrez ainsi des communications relatives aux nouveautés du portail, aux services d'Inaubi et à des informations techniques pertinentes.
      </p>
    </div>

    <div class="mt-6">
      <div class="flex items-center mb-4">
        <Checkbox v-model="consent1" inputId="consent1" :binary="true" />
        <label for="consent1" class="ml-2">Je confirme avoir lu et compris les conditions d'utilisation, notamment concernant l'IA et l'exactitude des données.</label>
      </div>
      <div class="flex items-center">
        <Checkbox v-model="consent2" inputId="consent2" :binary="true" />
        <label for="consent2" class="ml-2">J'accepte de recevoir des communications de la part d'Inaubi à l'adresse e-mail associée à ce compte.</label>
      </div>
    </div>

    <template #footer>
      <Button label="Continuer" @click="submitConsent" :disabled="!isConsented" />
    </template>
  </Dialog>
</template>

<script setup>
import { ref, computed, defineEmits } from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';

const emit = defineEmits(['consent-given']);

const showModal = ref(true);
const consent1 = ref(false);
const consent2 = ref(false);

const isConsented = computed(() => consent1.value && consent2.value);

const submitConsent = () => {
  if (isConsented.value) {
    emit('consent-given');
    showModal.value = false;
  }
};
</script>

<style scoped>
.prose h4 {
  font-size: 1.5em;
  margin-bottom: 1rem;
}
.prose h5 {
  font-size: 1.2em;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
}
</style>
